module.exports = __webpack_public_path__ + "img/caas2m-m@1.10805e21.webp";